import React, { useMemo, useState, Fragment } from 'react';
import * as PropTypes from 'prop-types';

import { getTransactionInfo } from '../../utils/appointment';
import { IconButton } from '../../../Button/IconButton';
import { COLORS } from '../../../../constants/styles';
import InfoPopover from '../../../InfoPopover';

function TransactionInfo({ appointment, formatMessage }) {
  const [isOpened, toggleTooltip] = useState(false);
  const [anchor, setAnchor] = useState(null);

  const handleOpenTransactionInfo = e => {
    setAnchor(e.currentTarget);
    toggleTooltip(true);
  };

  const list = useMemo(() => {
    return getTransactionInfo(formatMessage, appointment);
  }, [appointment]);

  return (
    <Fragment>
      <IconButton
        size={20}
        className="ml2 dib"
        name="info-default"
        fill={COLORS.blueDark}
        onClick={handleOpenTransactionInfo}
      />
      <InfoPopover
        onClose={() => toggleTooltip(false)}
        isOpen={isOpened}
        anchorEl={anchor}
        list={list}
      />
    </Fragment>
  );
}

TransactionInfo.propTypes = {
  appointment: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default TransactionInfo;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/TransactionInfo/index.jsx